<app-accessibility-toolbar *ngIf="portalLive == true"></app-accessibility-toolbar>

<div class="registre-container">
    <div class="registre-welcome-card d-flex flex-column align-items-start align-self-stretch">
        <div class="registre-welcome-card-content d-flex justify-content-between align-items-center align-self-stretch">
            <span>Registre {{ numeRegistru }}</span>
        </div>
    </div>

    <div *ngIf="step === 1" class="registre-content">
        <div class="registre-content-info d-flex flex-column align-items-start align-self-stretch">
            <div class="row info-section">
                <div class="col-sm-12 d-flex flex-row justify-content-start align-items-center pb-2 mb-2"
                    style="border-bottom: 2px solid #ccc;">
                    <p class="m-0 ps-3">Tipuri Registre</p>
                </div>
                <div class="col-sm-12 d-flex flex-column justify-content-start align-items-start p-3">
                    <div class="registre-info w-100 d-flex flex-column justify-content-start align-items-start"
                        *ngFor="let tipRegistru of tipuriRegistre; let i = index">
                        <div class="registre-info-header w-100">
                            <div class="row">
                                <div class="col-md-8 col-sm-12">
                                    <p class="m-0 clickable-element"
                                        (click)="onTipRegistruChange(tipRegistru.id, tipRegistru.title)">
                                        <u>{{i + 1}}.
                                            {{tipRegistru.title}}</u>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <mat-divider class="divider"></mat-divider>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="step === 2 && tipRegistru" class="registre-content">
        <div class="registre-content-container">
            <div *ngIf="tipRegistru === 'autorizari'">
                <app-registre-autorizari-comerciale
                    (backToRegistreClicked)="goBackToStep1()"></app-registre-autorizari-comerciale>
            </div>
            <div *ngIf="tipRegistru === 'urbanism'">
                <app-registre-urbanism (backToRegistreClicked)="goBackToStep1()"></app-registre-urbanism>
            </div>
        </div>
    </div>

    <div class="footer">
        <app-footer></app-footer>
    </div>
</div>